import appLogger from "@next-platform/client-common-core/logger/appLogger";

const silentSsoHandoffLogger = appLogger.withTag("SilentSsoHandoff");

export default silentSsoHandoffLogger;
